import { FormControlLabel, Radio, RadioGroup, InputLabel } from '@mui/material';
import React from 'react';
import { IFormController } from '../types';

const RadioButton = (props: IFormController) => {
  const { name, formik, label, options, required, disabled, ...rest } = props;
  
  if (!formik) return null;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const newValue = (event.target as HTMLInputElement).value;
    if (newValue === formik.values[name]) {
      formik.setFieldValue(name, null);
    } else {
      formik.setFieldValue(name, newValue);
    }
  };
  return (
    <>
      <InputLabel
        htmlFor={name}
        disabled={props.disabled}
        required={required}
        sx={{
          my: 2,
          textAlign: 'left',
          textStyle: 'none',
        }}
      >
        {label}
      </InputLabel>
      <RadioGroup
        aria-labelledby='demo-controlled-radio-buttons-group'
        {...formik.getFieldProps(`${name}`)}
        {...rest}
      >
        {options?.map((element) => {
          return (
            <FormControlLabel
              disabled={disabled}
              key={element.key} value={element.value}
              control={<Radio onClick={handleClick}/>}
              label={element.key}/>);
        })
        }
      </RadioGroup>
    </>
  );
};

export default RadioButton;